import { templateRouteParams } from '../shared/templateRoles';

/** What « Supprimer le projet… » prefills: a simulation, or the real thing. */
export type DeleteProjectMode = 'simulation' | 'deletion';

/**
 * The route parameters of a deletion template — the project's own
 * (`useTemplateFor(appType, 'delete')`: `project-delete` for Odoo since step
 * 7), or the one a deletion task ran from (the designated one for a
 * historical task) —, for the scaffolder's `selectedTemplate` route
 * (`/templates/:namespace/:templateName`).
 */
export function deleteTemplateParams(templateRef: string): {
  namespace: string;
  templateName: string;
} {
  return templateRouteParams(templateRef);
}

/**
 * The template page with its form prefilled: `templateHref` (the scaffolder's
 * route to the template) and `?formData=`, the JSON the scaffolder's stepper
 * starts from (`useFormDataFromQuery`, plugin-scaffolder-react).
 *
 * Only `project` and `dryRun`. Never `acceptDataLoss` nor `confirmation`: for
 * a real deletion the template requires both, and they must stay what the
 * user ticks and types on that page.
 */
export function deleteProjectHref(
  templateHref: string,
  project: string,
  mode: DeleteProjectMode,
): string {
  const formData = JSON.stringify({ project, dryRun: mode === 'simulation' });
  return `${templateHref}?formData=${encodeURIComponent(formData)}`;
}
